import { render, staticRenderFns } from "./TicketDetailsPage.vue?vue&type=template&id=4436011f&"
import script from "./TicketDetailsPage.vue?vue&type=script&lang=js&"
export * from "./TicketDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./TicketDetailsPage.vue?vue&type=style&index=0&id=4436011f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports